import React from 'react';

import { ResultListContainer, ResultItem } from './ThirdPartiesSearchResultList.styles';
import { ThirdPartyBasicData } from '../../types';

type ThirdPartiesSearchResultListProps = {
  thirdParties: Array<ThirdPartyBasicData>;
  onClick: (thirdParties: ThirdPartyBasicData) => void;
};

const ThirdPartiesSearchResultList: React.FC<ThirdPartiesSearchResultListProps> = ({
  thirdParties,
  onClick,
}) => {
  return (
    <ResultListContainer>
      {thirdParties.length === 0 ? (
        <p>No results found</p>
      ) : (
        thirdParties.map((item) => (
          <ResultItem key={item.id} onClick={() => onClick(item)}>
            {item.name}
            {' - '}
            {item.id}
          </ResultItem>
        ))
      )}
    </ResultListContainer>
  );
};

export default ThirdPartiesSearchResultList;
